import { Typography } from '@mui/material'
import styled from 'styled-components'

export const TruncatedText = styled(Typography)<{ lines: number }>`
  width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: ${(p) => p.lines};
  -webkit-box-orient: vertical;
  overflow: hidden;
`
